export default API => ({
    // 上传音频和文档
    getTree(data){
        return API({ url: `/resource/v1/category/getTree?type=${data.type}`, method:'get' });
    },
    delTree(url) {
        return API({ url:  `/resource/v1/category/delete?${url}`, method: 'post'})
    },
    addTree(data) {
        return API({ url: `/resource/v1/category/add`, data, method:  'post'})
    },
    editTree(data) {
        return API({ url: `/resource/v1/category/updateById`,data, method:  'post' })
    }
    
})
